import { environment } from "../../config";
import {
  iDataSuscripcionOrg,
  PostSuscriptFields,
  PutSuscriptFields,
} from "../../interfaces/SuperAdmin/Pages/iDataSuscripcion";
import {
  DeletedUserSuscription,
  iDataUserSuscription,
  UserSuscriptionFields,
} from "../../interfaces/SuperAdmin/Pages/iDataUserSuscription";
import { fetchData } from "./httpClient";

const { REACT_APP_API_CONTROL_TRANSACCIONAL, VERSION } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

/* 
------------------------------------------------- 
SUSCRIPCION
-------------------------------------------------
*/

export const getAllSuscriptions = (
  id_organizacion?: string,
  id_plan?: string
) =>
  fetchData<iDataSuscripcionOrg[]>({
    method: "GET",
    url: `${baseApiBroker}/suscripcion`,
    params: {
      ...(id_organizacion && { id_organizacion }),
      ...(id_plan && { id_plan }),
      version: VERSION,
    },
  });

export const getSuscriptionById = (id: string) =>
  fetchData<iDataSuscripcionOrg>({
    method: "GET",
    url: `${baseApiBroker}/suscripcion/${id}`,
  });

export const postSuscription = (data: PostSuscriptFields) =>
  fetchData<iDataSuscripcionOrg>({
    method: "POST",
    url: `${baseApiBroker}/suscripcion`,
    data,
  });

export const deleteSuscriptionById = (id: string) =>
  fetchData<{}>({
    method: "DELETE",
    url: `${baseApiBroker}/suscripcion/${id}`,
  });

export const putSuscriptionById = (data: PutSuscriptFields, id: string) =>
  fetchData<iDataSuscripcionOrg>({
    method: "PUT",
    url: `${baseApiBroker}/suscripcion/${id}`,
    data,
  });

/* 
------------------------------------------------- 
USUARIO-SUSCRIPCION
-------------------------------------------------
*/

/* Esta función como mínimo acepta un parámetro: o id_suscripcion o id_usuario */
export const getUsersInSuscription = (
  id_suscripcion?: string,
  id_usuario?: string
) =>
  fetchData<iDataUserSuscription[]>({
    method: "GET",
    url: `${baseApiBroker}/usuario-suscripcion`,
    params: {
      ...(id_suscripcion && { id_suscripcion }),
      ...(id_usuario && { id_usuario }),
    },
  });

export const postUsersInSuscription = (data: UserSuscriptionFields) =>
  fetchData<iDataUserSuscription[]>({
    method: "POST",
    url: `${baseApiBroker}/usuario-suscripcion`,
    data,
  });

export const deleteUsersInSuscription = (data: UserSuscriptionFields) =>
  fetchData<DeletedUserSuscription[]>({
    method: "DELETE",
    url: `${baseApiBroker}/usuario-suscripcion`,
    data,
  });
